import { useState } from 'react';

// components
import { TableCashiers } from './cashiers-table';
import { ModalEditCashier } from './modal-edit-cashier';
import { ModalEditCashierPassword } from './modal-edit-password';
import { EnableDisableCashier } from './modal-disable-enable';
import { AddCashier } from './modal-add-cashier';

// interfaces
import { ICashierQueryVariable, ICashierTable, mapGQLCashier } from '@/shared/interfaces';

// graphql
import { PageInfo, useCashiersQuery } from '@/generated/graphql';
import { Stack } from '@mui/system';
import { Button } from '@mui/material';

interface IProps {
  setCashiers: React.Dispatch<React.SetStateAction<ICashierTable[]>>;
  cashiers: ICashierTable[];
}

export const CashiersCmp = ({ cashiers, setCashiers }: IProps) => {
  const [cashier, setCashier] = useState<ICashierTable>();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditModalPassword, setOpenEditModalPassword] = useState(false);
  const [openDisableEnableModal, setOpenDisableEnableModal] = useState(false);
  const [addOpen, setAddOpen] = useState(false);

  const [cashiersQueryVariable, setCashiersQueryVariable] = useState<ICashierQueryVariable>({
    first: 25,
  });

  const [cashiersPageInfo, setCashiersPageInfo] = useState<PageInfo>();
  const [cashiersTotalCount, setCashiersTotalCount] = useState<number>(0);

  const cashiersQuery = useCashiersQuery({
    variables: cashiersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.cashiers.nodes.map((x) => mapGQLCashier(x));

      const mappedTableData: ICashierTable[] = mappedData.map((x) => ({
        id: x.id,
        firstName: x.firstName,
        lastName: x.lastName,
        name: `${x.firstName} ${x.lastName}`,
        contactNumber: x.contactNumber,
        username: x.user.username,
        cashBalance: x.cashBalance,
        isDisabled: x.user.isDisabled,
      }));

      setTimeout(() => {
        setCashiers(mappedTableData);
        setCashiersPageInfo(data.cashiers.pageInfo);
        setCashiersTotalCount(data.cashiers.totalCount);
      }, 100);
    },
  });

  const cashierEvent = (data: ICashierTable, eventName: string) => {
    console.log('🚀 ~ file: drawAdmins.page.tsx:124 ~ drawAdminEvent ~ eventName:', eventName, data);
    if (eventName == 'edit') {
      setCashier(data);
      setOpenEditModal(true);
    } else if (eventName == 'update password') {
      setCashier(data);
      setOpenEditModalPassword(true);
    } else if (eventName == 'disable enable') {
      setCashier(data);
      setOpenDisableEnableModal(true);
    }
  };

  const refetch = () => {
    cashiersQuery.refetch();
  };

  return (
    <>
      <Stack direction={'row'} justifyContent={'end'} mt={2}>
        <Button variant="contained" onClick={() => setAddOpen(true)}>
          Add Cashier
        </Button>
      </Stack>
      <TableCashiers
        rows={cashiers}
        setCashierQueryVariable={setCashiersQueryVariable}
        cashierQueryVariable={cashiersQueryVariable}
        totalCount={cashiersTotalCount}
        pageInfo={cashiersPageInfo}
        cashierEvent={cashierEvent}
        getCashierLoading={cashiersQuery.loading}
      />
      <ModalEditCashier setOpen={setOpenEditModal} open={openEditModal} data={cashier} refetch={refetch} />
      <ModalEditCashierPassword setOpen={setOpenEditModalPassword} open={openEditModalPassword} data={cashier} refetch={refetch} />
      <EnableDisableCashier setOpen={setOpenDisableEnableModal} isOpen={openDisableEnableModal} data={cashier} refetch={refetch} />
      <AddCashier open={addOpen} setOpen={setAddOpen} refetchData={refetch} />
    </>
  );
};
